export default __webpack_public_path__ + "static/program-circle-upcycled-pl-73971bf683cac204b6f4d94ffa9ff310.svg";